/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface CopyToClipboardCopyButtonArgs {
  border?: boolean;
  sticky?: boolean;
  buttonClassNames?: string;
  buttonContainerClassNames?: string;
  iconSize?: 'sm' | 'md';
  close: () => unknown;
}

export default class CopyToClipboardCopyButton extends Component<CopyToClipboardCopyButtonArgs> {
  get iconSize() {
    return this.args.iconSize ?? 'md';
  }
}
